import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PropertyTypes } from './components/PropertyTypes';
import { FeaturedDestinations } from './components/FeaturedDestinations';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { SearchResults } from './pages/SearchResults';
import { RoomSelection } from './pages/RoomSelection';
import { Payment } from './pages/Payment';
import { Confirmation } from './pages/Confirmation';
import { BookingProvider } from './hooks/useBooking';
type Page = 'home' | 'results' | 'room-selection' | 'payment' | 'confirmation';
function AppContent() {
  const [page, setPage] = useState<Page>('home');
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);
  const navigateTo = (newPage: Page) => {
    setPage(newPage);
  };
  return <div className="min-h-screen bg-white font-poppins selection:bg-luxury-blue selection:text-white flex flex-col" data-id="element-0">
      <Header forceSolid={page !== 'home'} onLogoClick={() => navigateTo('home')} data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <AnimatePresence mode="wait" data-id="element-3">
          {page === 'home' && <motion.div key="home" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-4">
              <HeroSection onSearch={() => navigateTo('results')} data-id="element-5" />
              <PropertyTypes data-id="element-6" />
              <FeaturedDestinations data-id="element-7" />
              <Testimonials data-id="element-8" />
            </motion.div>}

          {page === 'results' && <motion.div key="results" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} data-id="element-9">
              <SearchResults onSelectHotel={() => navigateTo('room-selection')} onEditSearch={() => navigateTo('home')} data-id="element-10" />
            </motion.div>}

          {page === 'room-selection' && <motion.div key="room-selection" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} data-id="element-11">
              <RoomSelection onSelectRoom={() => navigateTo('payment')} onBack={() => navigateTo('results')} data-id="element-12" />
            </motion.div>}

          {page === 'payment' && <motion.div key="payment" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} data-id="element-13">
              <Payment onConfirm={() => navigateTo('confirmation')} onBack={() => navigateTo('room-selection')} data-id="element-14" />
            </motion.div>}

          {page === 'confirmation' && <motion.div key="confirmation" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.4
        }} data-id="element-15">
              <Confirmation onHome={() => navigateTo('home')} data-id="element-16" />
            </motion.div>}
        </AnimatePresence>
      </main>

      <Footer data-id="element-17" />
    </div>;
}
export function App() {
  return <BookingProvider data-id="element-18">
      <AppContent data-id="element-19" />
    </BookingProvider>;
}